import axios from 'axios';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Utilisateur from "../../../../Models/Utilisateur";
import { useState } from "react";
import { Button, Form, Tabs, Space, Spin, Table } from 'antd';
import type { TabsProps } from 'antd';
import Demand from '../../../../Models/MMontantBloquer';
import { Box, Typography } from '@mui/material';
import SweetAlert from "sweetalert2";
import InputForm from "../../../InputT";
import SearchModal from "../../../SearchModal";
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import ParamsPicklist from "../../../../Types/ParamsPicklist"
import Tab1 from './Tab1';
import SearInputG from "../../../SearchInput"
import Data from '../../../../Data/Data.json'
import { Radio } from 'antd';

//mat 
import { useForm, Controller } from "react-hook-form";

//pour le tableau
import DataType from "../../../../Functions/Traitement/DataPeriodMHCQ";
import { ColumnGroupType, ColumnsType } from 'antd/es/table';
import { Crypter } from "../../../../Functions/Security/Crypter";
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import formatDate from '../../../../Functions/Traitement/fomatDate';
import RadioBox from "../../../Radiox";
import DataSelect from '../../../../Types/DataSelect';
import SelectOption from '../../../SelectOption';
import SelectOption2 from '../../../SelectOption2';



const VisualCheque = () => {
    // usestate pour remplir le tableau
    const [donnees, setData] = useState<DataType[]>([]);
    const [state, setstate] = useState(false)

    const dataOption2: DataSelect[] = [
        { label: "Client", value: "C" },
        { label: "Guichet", value: "G" }
    ]


    const dataOption3: DataSelect[] = [
        { label: "Impayé", value: "I" },
        { label: "Payé", value: "P" },
        { label: "Opposé", value: "O" }
    ]

    //column du tableau 
    const columns: ColumnsType<DataType> = [

        {
            title: 'Agence',
            dataIndex: 'AGCCPT',
        },
        {
            title: 'Numéro chèque',
            dataIndex: 'NUMCHQ',
        },
        {
            title: 'Numéro compte',
            dataIndex: 'NUMCPT',
        },
        {
            title: 'Situation',
            dataIndex: 'STACHQ',
        },
        {
            title: 'Type chèque',
            dataIndex: 'TYPCHQ',
        },
        {
            title: 'Status',
            dataIndex: 'CDETAT',
        },
        {
            title: 'Montant chèque',
            dataIndex: 'MTNCHQ',
        }
    ];

    // USER SESSION
    const [form] = Form.useForm();
    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const [loading, setLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false)
    const [ajoutActve, setAjoutActif] = useState(false)
    const [sbmit, setSbmit] = useState("")
    const [Impot, setImpot] = useState(false)

    const authHeader = useAuthHeader()

    let searchCompte: ParamsPicklist = { CodeAgence: Perss.codage, Table: "DEMANDECHQ", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: 'codeage', colfiltre: "CDETAT", valfiltre: '02', Choix: 22 }


    // Handle pour la selection des element dans le tableau
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    // function pour la selection du tab
    const onSelectChange = (newSelectedRowKeys: any) => {
        console.log('selectedRowKeys changed :) ', donnees[newSelectedRowKeys]);
        setSelectedRowKeys(newSelectedRowKeys);
        sessionStorage.clear();
        sessionStorage.setItem(Data.LocalVariable.FirstValueAuto, Crypter.encrypt(donnees[newSelectedRowKeys].NUMCHQ))
        sessionStorage.setItem(Data.LocalVariable.SecondValueAuto, Crypter.encrypt(donnees[newSelectedRowKeys].NUMDEMANDE))
        sessionStorage.setItem(Data.LocalVariable.ThirdValueAuto, Crypter.encrypt(donnees[newSelectedRowKeys].SERCHQ))
    };

    const rowSelection = {
        onChange: onSelectChange,
        selectedRowKeys,
    };

    const [checkboxValues, setCheckboxValues] = useState({
        checkbox1: false,
        checkbox2: false,
        checkbox3: false,
    });

    function handleCheckboxChange(events = require('events')) {
        const { name, checked } = events.target;
        setCheckboxValues({ ...checkboxValues, [name]: checked });
    }


    // usestate 
    function handleAnnul() {
        setSelectedRowKeys([]);
    }

    // Gestion des Items 
    const items: TabsProps['items'] = [
        {
            key: '2',
            label: (
                <span id='Tab'>
                    <UserOutlined />
                    Visualisation Chèque
                </span>
            ),
            children: <Tab1 />, //form={form}
        },
    ];

    // function Handle
    function HandleAnnul() {
        form.resetFields();
        setSelectedRowKeys([]);
        setImpot(false);
        setData([]);
    }

    function HandleOppose() {
        Consultableau();
        setSelectedRowKeys([]);
    }



    // function consult tableableau
    function Consultableau() {
        localStorage.clear()
        setSelectedRowKeys([]);

        if (form.getFieldValue("TYPE") != 'G' && form.getFieldValue("NUMCPT") == null) {
            SweetAlert.fire({ title: "Renseigner le numéro de compte", text: "", icon: "warning" })
        } else {
            if (form.getFieldValue("TYPE") == null) {
                SweetAlert.fire({ title: "Renseigner le type de chéque a valider", text: "", icon: "warning" })
            } else {
                if (form.getFieldValue("ETAT") == null) {
                    SweetAlert.fire({ title: "Renseigner l'état du chéque", text: "", icon: "warning" })
                } else {

                    let a = form.getFieldValue("NUMCPT");
                    //alert(a)
                    let b = form.getFieldValue("ETAT")
                    //alert(b)
                    let c = form.getFieldValue("TYPE");
                    //alert(c)
                    let d = Perss.codage;
                    setImpot(true);

                    setLoading(true)
                    let config = {
                        method: 'get',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.AllreadHCQ,
                        headers: {
                            'CypherNUMCPT': Crypter.encrypt(a),
                            'CypherETAT': Crypter.encrypt(b),
                            'CypherTYPE': Crypter.encrypt(c),
                            'Cyphercodeage': Crypter.encrypt(d),
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json',
                        },
                    };
                    // MAPPING DANS LE TABLEAU
                    let dat: DataType[] = [];
                    axios.request(config)
                        .then((response) => {
                            setLoading(false);

                            if (response.data) {

                                let datas = JSON.parse(JSON.stringify((response.data.Result)));
                                console.log(datas)
                                datas.map((val: any, key: any) => {
                                    dat.push({
                                        key: key,
                                        NUMCHQ: val.NUMCHQ,
                                        SERCHQ: val.SERCHQ,
                                        DATPAI: val.DATPAI,
                                        MTNCHQ: val.MTNCHQ,
                                        TYPCHQ: val.TYPCHQ,
                                        NUMRAP: val.NUMRAP,
                                        STACHQ: val.STACHQ,
                                        DATSAI: val.DATSAI,
                                        datcre: val.datcre,
                                        AGCCPT: val.AGCCPT,
                                        NUMCPT: val.NUMCPT,
                                        UTILIS: val.UTILIS,
                                        CDETAT: val.CDETAT,
                                        UTIVAL: val.UTIVAL,
                                        NUMDEMANDE: val.NUMDEMANDE,
                                        DATVAL: val.DATVAL,
                                        NBCHQS: val.NBCHQS,
                                        NBCHQR: val.NBCHQR,
                                        trie: val.trie,
                                    })
                                })
                                setData((dat))
                            } else {
                                SweetAlert.fire({ title: "Error", text: "Aucun Element dans le tableau", icon: "warning" })
                            }
                            setLoading(false)
                        })
                        .catch((error) => {
                            setLoading(false);
                            SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                        });
                }
            }
        }

    }

    // function Onfinish
    const onFinish = (values: any) => {


    }



    // control du forms 
    const onFinishFailed = (errorInfo: any) => {
        setLoading(true);
        setLoading(false);
    };

    //MUI
    const { control, handleSubmit } = useForm();

    const verifSubmit = () => {
        if (!isSubmit) {
            SweetAlert.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };
    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'><b>Visualisation chèque : {window.location.pathname.toUpperCase()}</b></Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }} >
                <Form disabled={ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={false} onClick={() => { Consultableau() }} type="ghost" block>
                                    Afficher
                                </Button>
                                {/* <Button size='large' className='bt_add' disabled={false} onClick={() => { }} type="ghost" htmlType='submit' block  >
                                    Valider
                                </Button> */}
                                <Button size='large' className='bt_add' disabled={false} onClick={() => { HandleAnnul() }} type="ghost" block  >
                                    Actualiser
                                </Button>

                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>
                            <div className='tabItem' >
                                <div style={{ display: 'block flow' }}  >
                                    <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >
                                        <Box fontStyle="inherit" className='border-left'>
                                            <legend> Visualisation des chèques </legend>
                                            <Box className='border' style={{ display: 'flex' }} sx={{ mb: 2, marginTop: 1 }}>
                                                {/* <Form.Item style={{ width: '40%', marginBottom: -10, paddingLeft: 10, marginTop: -20 }}>  paddingLeft:40 */}
                                                {/* //<SelectOption2 marginTop={'10px'} label="Type chèque" name="TYPE" Option={dataOption2} width="100%"/> */}
                                                {/* <SearchModal width={5} disabled={Impot} Titre="" label="N° compte" name="NUMCPT" Taille1={'100%'} Taille2={'100%'} Parametre={searchCompte} form={form} /> */}
                                                {/* //<SelectOption2 Option={dataOption3} marginTop={'10px'}  label='Etat du chèque  :' width="100%" name="ETAT" /> */}

                                                {/* </Form.Item> */}
                                                <Box style={{ width: "30%" }}>
                                                    <SelectOption Option={dataOption2} width={8} label='Type chèque' Size={'200%'} name="TYPE" />
                                                </Box>
                                                { form.getFieldValue("TYPE") === "C" && <Box style={{}}>
                                                    <SearchModal notRequired width={5} disabled={Impot} Titre="" label="N° compte" name="NUMCPT" Taille1={'100%'} Taille2={'100%'} Parametre={searchCompte} form={form} />
                                                </Box>}

                                                <Box style={{ width: "30%" }}>
                                                    <SelectOption Option={dataOption3} width={8} label='Etat chèque:' Size={'200%'} name="ETAT" />
                                                </Box>


                                            </Box>
                                            <Box fontStyle="inherit" className='border' sx={{ mb: 2, marginTop: 1 }}>

                                            </Box>

                                            <Box fontStyle="inherit" className='border' style={{ marginTop: -15 }} sx={{ mb: 2, marginTop: 1 }} >
                                                <Spin spinning={loading}>
                                                    <Table dataSource={donnees} columns={columns} style={{ textAlign: "center", width: '100%' }} size='small' pagination={false} scroll={{ y: 400, x: 400 }} />
                                                </Spin>
                                            </Box>

                                        </Box>

                                    </Box>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
}

export default VisualCheque;